// https://github.com/feross/fromentries/blob/master/index.js
function fromEntries(iterable) {
  return [...iterable].reduce((obj, [key, val]) => {
    // eslint-disable-next-line no-param-reassign
    obj[key] = val;
    return obj;
  }, {});
}

export default fromEntries;
